angular.module("vgresiduos").factory("residueService", [
	"$http",
	"$q",
	"accountService",
	"recipientService",
	function ($http, $q, accountService, recipientService) {
		"use strict";

		const cacheTimeoutInMilliseconds = 5 * 60 * 1000;
		const organizationUnitResiduesCache = {};

		function getOrganizationUnitResidueApiBaseRequestUrl() {
			const currentClient = accountService.getCurrentClient();
			return (
				Vgr.constants.residuesHostUrl +
				Vgr.resources.residues.organizationUnitResidues
					.replace("[ORGANIZATION]", currentClient.organization.id)
					.replace("[ORGANIZATION_UNIT]", currentClient.code)
			);
		}

		// O Residues devolve o Guid do recipiente; a tela de destinação seleciona o recipiente da unidade pelo id numérico
		function getOrganizationUnitRecipientIdByRecipientId() {
			return recipientService.listClientRecipientsCore().then(function (response) {
				const organizationUnitRecipientIdByRecipientId = {};
				for (const organizationUnitRecipient of response.data) {
					organizationUnitRecipientIdByRecipientId[organizationUnitRecipient.recipientId] =
						organizationUnitRecipient.id;
				}
				return organizationUnitRecipientIdByRecipientId;
			});
		}

		// O Residues não pagina nem filtra por texto, então a unidade é carregada uma vez e filtrada aqui
		function listLegacyOrganizationUnitResidues() {
			const currentClient = accountService.getCurrentClient();
			const cacheKey = currentClient.organization.id + "-" + currentClient.code;
			const cached = organizationUnitResiduesCache[cacheKey];
			if (cached && cached.expiresAt > Date.now()) {
				return cached.promise;
			}

			const promise = $q
				.all([$http.get(getOrganizationUnitResidueApiBaseRequestUrl()), getOrganizationUnitRecipientIdByRecipientId()])
				.then(function ([residuesResponse, organizationUnitRecipientIdByRecipientId]) {
					return residuesResponse.data
						.map(function (residue) {
							return Vgr.dtoMappings.residue.fromResiduesToV2(residue, organizationUnitRecipientIdByRecipientId);
						})
						.sort(function (residue1, residue2) {
							return (residue1.Name || "").localeCompare(residue2.Name || "");
						});
				});

			organizationUnitResiduesCache[cacheKey] = {
				promise: promise,
				expiresAt: Date.now() + cacheTimeoutInMilliseconds
			};
			promise.catch(function () {
				if (organizationUnitResiduesCache[cacheKey]?.promise === promise) {
					delete organizationUnitResiduesCache[cacheKey];
				}
			});

			return promise;
		}

		// Mantém o contrato do antigo api/v1/client-residues: skip é o índice da página e nameLike busca em código e nome
		const _listClientResidues = function (params) {
			params = params || {};

			return listLegacyOrganizationUnitResidues().then(function (residues) {
				let filteredResidues = residues.filter(function (residue) {
					return (
						(!params.active || residue.Active) &&
						(Vgr.util.isStringIncluded(residue.Code, params.nameLike) ||
							Vgr.util.isStringIncluded(residue.Name, params.nameLike))
					);
				});
				const count = filteredResidues.length;

				if (params.skip != null && params.take != null) {
					const take = params.take > 0 ? params.take : 100;
					const start = Math.max(params.skip, 0) * take;
					filteredResidues = filteredResidues.slice(start, start + take);
				}

				return {
					data: {
						Residues: angular.copy(filteredResidues),
						Count: count
					}
				};
			});
		};

		const _getClientResidue = function (residueId) {
			return $q
				.all([
					$http.get(getOrganizationUnitResidueApiBaseRequestUrl() + residueId),
					getOrganizationUnitRecipientIdByRecipientId()
				])
				.then(function ([residueResponse, organizationUnitRecipientIdByRecipientId]) {
					return {
						...residueResponse,
						data: {
							Residue: Vgr.dtoMappings.residue.fromResiduesToV2(
								residueResponse.data,
								organizationUnitRecipientIdByRecipientId
							)
						}
					};
				});
		};

		const _getResidueQuantitiesByAreaNotControlStock = function (disposalResidueQuantities) {
			const result = [];
			if (disposalResidueQuantities) {
				for (const quantity of disposalResidueQuantities) {
					result.push({
						...quantity,
						AreaCode: GetAreaCode(quantity)
					});
				}
			}
			return result;
		};

		function GetAreaCode(quantity) {
			let areaCode;
			if (quantity.SelectedArea) {
				areaCode = quantity.SelectedArea.code;
			} else if (quantity.Area) {
				areaCode = quantity.Area.Code;
			}

			return areaCode;
		}

		return {
			getResidueQuantitiesByAreaNotControlStock: _getResidueQuantitiesByAreaNotControlStock,

			listClientResidues: _listClientResidues,
			getClientResidue: _getClientResidue
		};
	}
]);
